<template>
  <div>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Communication</h1>
    </div>
    <div v-show="is_loading">
      <table-skeleton />
    </div>
    <div class="row" v-show="!is_loading">
      <div class="col-12">
        <a class="btn btn-sm btn-primary mr-2" :href="'/communication/action?method='+data.id" v-for="(data,index) in arr_method" :key="index">Send {{ data.name }}</a>
      </div>
      <div class="col-12 mt-4">
        <div class="custom-control custom-checkbox mr-sm-2 custom-control-inline" v-for="(data,index) in arr_method" :key="index">
          <input type="checkbox" class="custom-control-input" @click="select_method(index)" :name="'method_'+data.id" :id="'method_'+data.id">
          <label class="custom-control-label" :for="'method_'+data.id">{{ data.name }}</label>
        </div>
      </div>
      <div class="col-12 mt-2">
        <div class="custom-control custom-radio custom-control-inline" v-for="(data,index) in arr_type" :key="index">
          <input type="radio" :id="'radio_type_'+data.name" name="type" :value="data.id" v-model="selected_type" @click="select_type(index)" class="custom-control-input">
          <label class="custom-control-label" :for="'radio_type_'+data.name">{{ data.name }}</label>
        </div>
      </div>
      <div class="col-12 mt-2">
        <custom-table 
          :arr="arr" 
          :total_page="total_page" 
          :url_update="url_update+'?arr_communication_method='+JSON.stringify(selected_method)+'&communication_type='+selected_type" 
          url_detail="/communication/detail"
          :arr_id="arr_id" 
          :force_update="now"
          :arr_header="arr_header" 
          @on_refresh_start="on_refresh_start" 
          @on_refresh_end="on_refresh_end"/>
      </div>
    </div>
  </div>
</template>

<script>
import custom_table from '@/layout/table'
import table_skeleton from '@/layout/table_skeleton'

export default {
  components:{
    'custom-table': custom_table,
    'table-skeleton': table_skeleton,
  },
  data(){
    return{
      arr_method:[],
      arr_type:[],
      selected_type: '1',
      selected_method: [],
      arr: [
        {
          date: moment().format('DD MMM YYYY'),
          subject: 'Test',
          method: 'Email',
          type: 'Personal to test',
          status: 'Success',
        },
        {
          date: moment().format('DD MMM YYYY'),
          subject: 'Test',
          method: 'Email',
          type: 'Personal to test',
          status: 'Success',
        },
      ],
      arr_header: ['date','subject','method','type','status',],
      arr_id: ['1','2'],
      total_page: 1,
      is_loading: true,
      url_update: '/communication',
      now: '',
    }
  },
  async created(){
    await this.get_method()
    await this.get_type()
    await this.get_data()
    this.is_loading = false
  },
  methods:{
    on_refresh_start(){
      this.is_loading = true
    },
    on_refresh_end(){
      this.is_loading = false
    },
    select_method(index){
      var index_to_splice = 0
      var counter = 0
      for(let x in this.selected_method){
        if(this.selected_method[x] == this.arr_method[index].id){
          index_to_splice = x
          break
        }
        counter++
      }

      if(counter == this.selected_method.length)
        this.selected_method.push(this.arr_method[index].id)
      else
        this.selected_method.splice(index_to_splice,1)

      this.now = moment().format('YYYY-MM-DD HH:mm:ss')
    },
    select_type(index){
      this.selected_type = this.arr_type[index].id
      this.now = moment().format('YYYY-MM-DD HH:mm:ss')
    },
    async get_method(){
      try{
        var response = await axios.get(base_url+'/communication-method/all')

        var response_data = response.data
        if(response_data.status == "success"){
          this.arr_method = response_data.data
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
    async get_type(){
      try{
        var response = await axios.get(base_url+'/communication-type/all')

        var response_data = response.data
        if(response_data.status == "success"){
          this.arr_type = response_data.data

          for(let x in this.arr_type){
            if(this.arr_type[x].name == 'All'){
              this.selected_type = this.arr_type[x].id
              break              
            }
          }
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
    async get_data(){
      try{
        var response = await axios.get(base_url+'/communication?api_type=web-admin')

        var response_data = response.data
        if(response_data.status == "success"){
          this.arr = response_data.arr
          this.arr_header = response_data.arr_header
          this.arr_id = response_data.arr_id
          this.total_page = response_data.total_page
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
  }
}
</script>
